module.exports = __webpack_public_path__ + "static/media/plus-icn.c7a1d25f.svg";